<template>
  <!-- <app-template-area :area-id="13" /> -->
  <div class="blogCarousel">
    <div v-if="!hideTitle" class="blogCarousel__intro text-center">
      <h3>Travel Notes</h3>
      <p>Let us take you somewhere</p>
    </div>
    <div class="blogEnclosure">
      <!-- TRAVEL NOTES  -->
      <ssr-carousel
        v-if="blogIds"
        :key="blogContent ? blogContent.length : null"
        :slides-per-page="null"
        :paginate-by-slide="false"
        :center="false"
        :loop="false"
        :show-arrows="false"
        :overflow-visible="false"
        :gutter="32"
        class="blog"
        :responsive="[
          {
            maxWidth: 800,
            slidesPerPage: 1,
            gutter: 16,
            peekRight: &quot;calc(10%)&quot;
          }
        ]"
      >
        <a v-for="(d, i) in sortedBlogContent" :key="i" :href="d.blog.cmsRelativeURL" class="slide link-unstyle" :class="d.blog.class">
          <div class="slide--image lazyload" :style="getBackground(d.blog)" :alt="d.blog.imageAltTag" :class="{ 'alt-size' : i % 2 != 0 }" />
          <div class="slide--content text-dark">
            <p class="slide--content_info uppercase" v-html="getCategory(d.blog)" />
            <p class="slide--content_title" v-html="d.blog.languageSpecificBlogs[0].title" />
          </div>
        </a>
      </ssr-carousel>
      <!-- GUIDE -->
      <ssr-carousel
        v-else
        :key="content ? content.length : null"
        :slides-per-page="null"
        :paginate-by-slide="false"
        :center="false"
        :loop="false"
        :show-arrows="false"
        :overflow-visible="false"
        :gutter="32"
        class="blog"
        :responsive="[
          {
            maxWidth: 800,
            slidesPerPage: 1,
            gutter: 16,
            peekRight: &quot;calc(10%)&quot;
          }
        ]"
      >
        <app-link v-for="(d, i) in content" :id="d.id" :key="i" :type="d.type" class="slide link-unstyle" :class="d.class">
          <div class="slide--image lazyload" :style="getContentBackground(d)" :alt="d.blog" :class="{ 'alt-size' : i % 2 != 0 }" />
          <div class="slide--content text-dark">
            <p v-if="d.blogCategory" class="slide--content_info uppercase" v-html="d.blogCategory" />
            <p class="slide--content_title" v-html="d.blogDescription" />
          </div>
        </app-link>
      </ssr-carousel>
    </div>
    <div class="blogCarousel__cta">
      <app-link id="1049" type="page" class="btn-secondary-dark-sm">
        Read Travel Notes
      </app-link>
    </div>
  </div>
</template>

<script>
import SsrCarousel from 'vue-ssr-carousel';
import AppLink from './AppLink.vue';

export default {
  name: 'BlogCarousel',
  components: { AppLink, SsrCarousel },
  props: {
    hideTitle: { type: Boolean, default: false },
    content: { type: Array, required: false },
    blogIds: { type: Array },
  },
  data() {
    return {
      blogContent: null,
    };
  },
  computed: {
    sortedBlogContent() {
      if (this.blogContent) {
        return this.blogContent.sort((a, b) => ((a.order > b.order) ? 1 : ((b.order > a.order) ? -1 : 0)));
      }
    },
  },
  created() {
    this.fetchBlogContent();
  },
  methods: {
    fetchBlogContent() {
      if (this.blogIds) {
        const arr = [];
        this.blogIds.forEach((id, i) => {
          this.$store.dispatch('blogs/fetchBlogArticlePageById', id).then((res) => {
            arr.push({ blog: res, order: i });
          });
        });
        this.blogContent = arr;
      }
    },
    getCategory(d) {
      switch (d.categoryId) {
        default: '';
          break;
        case 3137: return 'History and Culture';
        case 3140: return 'Wellness and Relaxation';
        case 3130: return 'Food and Drink';
        case 3151: return 'Activities and Adventure';
        case 3186: return 'Inspiration';
        case 3192: return 'Resources';
      }
    },
    getContentBackground(d) {
      return {
        backgroundImage: `url('${d.image}')`,
      };
    },
    getBackground(d) {
      return {
        backgroundImage: `url('https://www.thethinkingtraveller.com/Media/${d.imagePath}')`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../assets/styles/settings/_config.scss';

.blogCarousel {
  background-color: $yellowStone;
  padding: 2em 1em 1em;
  width: 100%;
  overflow: hidden;
  &__intro {
    max-width: 1152px;
    margin: 3em auto;
    h3 {
      font-size: 16px;
      font-weight: 400;
      @media screen and (min-width: 480px) {
        font-size: 24px;
      }
    }
    & p {
      font-family: $font-family-editorial;
      margin-bottom: 1em;
      font-weight: 200;
      font-size: 32px;
      letter-spacing: -0.01em;
      @media screen and (min-width: 480px) {
        font-size: 40px;
      }
    }
  }
  .blogEnclosure {
    position: relative;

    .blog {
      max-width: 1920px;
      margin: 2em auto;
      color: $stoneWhite;
      display: flex;
      align-items: flex-end;
      overflow-x: auto;
      margin: 0 auto;
      flex: none;
      scrollbar-width: none;
      &::-webkit-scrollbar-track {
        background-color: transparent;
      }
      &::-webkit-scrollbar-thumb {
        background: transparent;
      }
      &::-webkit-scrollbar-thumb:hover {
      background: transparent;
      }
      &::-moz-scrollbar-track {
      background: transparent;
      }
      &::-moz-scrollbar-thumb {
      background: transparent;
      }
      @media screen and (max-width: 480px) {
        display: block;
        overflow-x: hidden;
      }
      &::v-deep .ssr-carousel-slides {
        position: initial !important;
      }
      &::v-deep .ssr-carousel-track {
        align-items: end;
        margin-right: 20px;
      }
      .slide {
        width: 312px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        background-size: cover;
        background-position: center;
        position: relative;
        @media screen and (max-width: 480px) {
          width: 280px;
          flex-shrink: initial;
        }
        &:first-child {
          margin-left: 24px;
          @media screen and (max-width: 480px) {
            margin-left: 0;
          }
        }
        &--image {
          height: 416px;
          width: 312px;
          background-size: cover;
          background-position: center;
          @media screen and (max-width: 480px) {
            height: 372px;
            width: 280px;
          }
          &.alt-size {
            width: 312px;
            height: 312px;
            @media screen and (max-width: 480px) {
              width: 280px;
              min-width: 280px;
              height: 280px;
            }
          }
        }
        &--content {
          margin-top: 24px;
          &_info {
            font-size: 12px;
            margin-bottom: 5px;
          }
          &_title {
            font-size: 18px;
            height: 100px;
          }
        }
      }
    }
  }

  &__cta {
    padding: 3em 0;
    text-align: center;
  }
}
</style>
